<template>
  <div>
    <div id="bible_main">
      <h2>
        <b-button v-b-toggle.sidebar-variant>Books </b-button>
        {{ currentBook.name }}
      </h2>
      <b-card no-body>
        <b-tabs pills card>
          <b-tab
            v-for="(aChapter, i) in currentBook.chapters"
            :title="`${i + 1}`"
            :key="i"
          >
            <b-card-text>
              <h3 v-for="(aVerse, j) in aChapter" :key="`${j}`">
                <sup>{{ j + 1 }}</sup> {{ aVerse }}
              </h3>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <div>
      <b-sidebar
        id="sidebar-variant"
        title="Books"
        bg-variant="dark"
        text-variant="light"
        shadow
      >
        <div class="px-3 py-2">
          <b-img :src="`${assetsURLHome}/img/fruits.png`" fluid thumbnail />
          <h2
            v-for="(aBook, i) in bookNames"
            :key="`bn_${i}`"
            @click="handleBookClicked(aBook)"
            class="book-name-labels"
          >
            {{ aBook }}
          </h2>
        </div>
      </b-sidebar>
    </div>
  </div>
</template>

<script>
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import enkjvJSON from "../../assets/json/en_kjv.json";
export default {
  name: "Display_Bible",
  mixins: [ResourceBlockDisplay],
  components: {},
  mounted() {
    //THIS APPS SOUND EFFECTS -- onlyset up once
    if (this.settings_isSoundOn) {
      //switch it to hasSoundEffects or playSoundEffects
      this.setUpSoundEffects();
    }
    this.currentBook = this.getBookFromName("Genesis");
  },
  computed: {
    settings_hasBgMusic() {
      return this.settings && this.settings.user
        ? this.settings.user.hasBGMusic
        : true;
    },
    settings_isSoundOn() {
      return this.settings && this.settings.user
        ? this.settings.user.isSoundOn
        : true;
    },
    bookNames() {
      let bookNames = [];
      enkjvJSON.forEach(aBook => {
        bookNames.push(aBook.name);
      });
      return bookNames;
    }
  },
  methods: {
    handleBookClicked(bookName) {
      this.currentBook = this.getBookFromName(bookName);
    },
    getBookFromName(bookName) {
      let books = enkjvJSON.filter(aBook => {
        return aBook.name === bookName;
      });
      return books[0];
    },
    setUpTheme() {},
    setUpSoundEffects() {
      this.soundEffects.flip = new Audio(
        `${this.assetsURLHome}/_audio/effects/cardflip.wav`
      );
      this.soundEffects.successJingle = new Audio(
        `${this.assetsURLHome}/_audio/effects/success-jingle.ogg`
      );
    }
  },
  data() {
    return {
      /* Overrides */
      assetsURLHome: "/assets/apps/bible/",
      /* App Specific */
      enkjvJSON,
      currentBook: {
        abbrv: "gn",
        name: "Genesis",
        chapters: []
      },
      soundEffects: {
        flip: null,
        successJingle: null
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.book-name-labels {
  background-color: #0d0d21;
  cursor: pointer;
}
</style>
